module.exports = __webpack_public_path__ + "media/images/icons/material/star-half-full-466f6ef24bb693e44a502491e0f482b1.svg";